'use client'

import dynamic from 'next/dynamic'
import type ReactH5AudioPlayer from 'react-h5-audio-player'
import type { ComponentProps } from 'react'
import 'react-h5-audio-player/lib/styles.css'

const H5AudioPlayer = dynamic(() => import('react-h5-audio-player'), {
  ssr: false,
})

type AudioPlayerProps = ComponentProps<typeof ReactH5AudioPlayer>

export const AudioPlayer = (props: AudioPlayerProps) => (
  <H5AudioPlayer {...props} />
)

export default AudioPlayer
